import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import {
  QueryClient,
  QueryClientProvider
} from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
} from "react-router-dom";
import Home from './components/Home.jsx';
import AdminLogin from './components/AdminLogin.jsx';
import Dashboard from './components/Dashboard.jsx';
import QuranView from './components/pages/QuranView.jsx';
import Questions from './components/pages/Questions.jsx';
import Q1 from './components/pages/Q1.jsx';
import Q2 from './components/pages/Q2.jsx';
import PublicView from './components/pages/PublicView.jsx';

const queryClient = new QueryClient();

const router = createBrowserRouter([
  // {
  //   path: "/",
  //   element: (
  //     <div className='flex'>
  //       <h1>Hello World</h1>
  //       <Link to="home">Home</Link>
  //       <Link to="login">Login</Link>
  //       <Link to="about">About Us</Link>
  //     </div>
  //   ),
  // },
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "adminlogin",
    element: <AdminLogin />,
  },
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "view",
    element: <QuranView />,
  },
  {
    path: "questions",
    element: <Questions />,
  },
  {
    path: "q1",
    element: <Q1 />,
  },
  {
    path: "q2",
    element: <Q2 />,
  },
  {
    path: "about",
    element: <div>About</div>,
  },
  {
    path: "public",
    element: <PublicView />,
  },
]);



ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
)
